import React, { useState, useEffect } from 'react';
import { Form, Select, Row, Col, Button, Modal, Select as AntSelect, } from 'antd';
import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import EditableTable from 'src/components/common/editableTable';
import newAlert from 'src/components/newAlert';
import TreeSelect from 'src/components/common/treeSelect';
import { DansColumns } from './dataStructure/data';
import { start_loading, end_loading } from '../../../core/actions/loader';

const TYPE_MAPPING = {
  'Орлого': 'orlogo_angilal',
  'Баланс': 'balance_angilal'
};
const { Option } = Select;
const DansMultAgilal = ({

  listData = {},
  listDef = null, onCancel = {}, visible }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const socket = useSelector((state) => state.socket);

  const [tableData, setTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [SelectedDansRows, setSelectedDansRows] = useState([]);
  const [SelectedDansIds, setSelectedDansIds] = useState([]);
  const [subList, seTsubList] = useState([]);

  
  const filterTableData = (dansTurul) => {
    if (!dansTurul || rawData.length === 0) return;
    
    const filteredData = rawData
      .filter(row => row.dans_turul === dansTurul)
      .slice(0, 50)
      .map((row, index) => ({
        ...row,
        key: index // Use row.id if available, otherwise use index
      }));
    
    setTableData(filteredData);
    // Clear selections when filter changes
    setSelectedDansIds([]);
    setSelectedDansRows([]);
  };
  
  function select_data() {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        // Store the raw data
        setRawData(data.content.table_data.json_array);
        // Initial filter based on current dans_turul
        const currentDansTurul = form.getFieldValue('dans_turul');
        filterTableData(currentDansTurul || 'Баланс'); // Default to 'Баланс' if no value
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });

    const page = 1;
    const size = 500;
    const search = {
      dans_dugaar: '',
      angilalt: 'Ангилаагүй',
    };

    socket.emit('request_in', {
      channel: 'ts001_02_dans_control',
      content: {
        action_type: 'get_sanhuu_dans_list',
        paging: { page, size, search },
      },
    });

    dispatch(start_loading({}));
  }

  useEffect(() => {
    if (visible) {
      select_data();
    }
  }, [visible]);

  const CategorySelect = () => {
    const dansTurul = Form.useWatch('dans_turul', form);
    const type = startWith(dansTurul);
    
    return (
      <Form.Item
        name="dans_angilal_id"
        label="Ангилал"
        labelAlign="left"
        rules={[
          {
            required: true,
            message: 'Ангилал сонгоно уу',
          },
        ]}
      >
        <TreeSelect
          onChange={setDans}
          data={get(listData, `${type}`)}
          placeholder="Ангилал сонгоно уу"
        />
      </Form.Item>
    );
  };

  const startWith = (value) => {
    return TYPE_MAPPING[value] || 'balance_angilal'; // default to balance_angilal if value not found
  };

  const closeModal = () => {
    form.resetFields();
    onCancel('visible2');
  };

  const handleSave = (values) => {
  socket.on('request_out', (data) => {
    socket.removeAllListeners('request_out');
    if (data.status === '0') {
      newAlert({ type: 'success', msg: 'Амжилттай хадгалагдлаа' });

      
      setSelectedDansIds([]);
      setSelectedDansRows([]);
      setRawData([]);  // Clear raw data before refetch
      setTableData([]);  // Reset table data immediately

      closeModal()
      
    } else {
      newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
    }
    dispatch(end_loading({}));
  });

  const temp_data = {
    ...values,
    data_table: SelectedDansRows,
  };
  socket.emit('request_in', {
    channel: 'ts001_02_dans_control',
    content: {
      action_type: 'set_sanhuu_dans_info_mult',
      json_array: { ...temp_data },
    },
  });
  dispatch(start_loading({}));
};

  
  const onFinish = (values) => {
    handleSave(values);
  };

  const setDans = (value) => {
    console.log(listData);
    form.setFieldsValue({
      sub_angilal_id: null
    });
    seTsubList(
      listData?.ded_angilal.filter((item) => item.angilal_id === value)
    );
  };

  const geTvalue = (value) => {
    form.setFieldsValue({
      children: [...value],
    });
  };

  const rowSelection = {
    selectedRowKeys: SelectedDansIds,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedDansRows([...selectedRows]);
      setSelectedDansIds([...selectedRowKeys]);
    },
  };

  const layout = {
    labelCol: {
      xs: { span: 5 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 19 },
      sm: { span: 19 },
    },
  };

  return (
    <Modal
      className="custom-modal"
      title="Данс ангилал"
      open={visible}
      width="80%"
      footer={null}
      onCancel={() => {
        onCancel('visible2');
      }}
    >
      <div className="dans-medeelel-container">
        <Form
          form={form}
          onFinish={onFinish}
          className="register-form"
          {...layout}
          size="small"
        >

          <Form.Item
            name="dans_turul"
            label="Төрөл"
            labelAlign="left"
            
            rules={[
              {
                required: true,
                message: '',
              },
            ]}
          >
            <AntSelect defaultValue="Баланс" onChange={(value) => {filterTableData(value);}}>
              <AntSelect.Option value="Баланс">Баланс</AntSelect.Option>
              <AntSelect.Option value="Орлого">Орлого</AntSelect.Option>
            </AntSelect>
          </Form.Item>
          <CategorySelect/>
          <Form.Item name="sub_angilal_id" label="Дэд ангилал" labelAlign="left">
            <AntSelect
              defaultValue={null}
              disabled={!form.getFieldValue('dans_angilal_id')}
            >
              <AntSelect.Option value={null}>---</AntSelect.Option>
              {subList.map((i) => (
                <AntSelect.Option value={i?.id}>
                  {i?.code} {i?.ner}
                </AntSelect.Option>
              ))}
            </AntSelect>
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {visible && tableData  && (
              <EditableTable
                dataSource={tableData}
                rowSelection={rowSelection}
                columns={DansColumns()}
                geTvalue={geTvalue}
                scroll={{ y: '500' }}
              />
            )}
          </Form.Item>
          <Row style={{ marginTop: 10 }}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button
                onClick={() => {
                  closeModal();
                }}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Буцах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Хадгалах
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default DansMultAgilal;
